module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_VCNC.43ac29b57c138fc4e5e77d8a84b74783.png";